"use strict";
// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Completions = exports.Chat = void 0;
var chat_1 = require("./chat.js");
Object.defineProperty(exports, "Chat", { enumerable: true, get: function () { return chat_1.Chat; } });
var index_1 = require("./completions/index.js");
Object.defineProperty(exports, "Completions", { enumerable: true, get: function () { return index_1.Completions; } });
//# sourceMappingURL=index.js.map